import React, { useEffect, useMemo, useState } from 'react'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { FaArrowLeft, FaDownload, FaEdit, FaFileExcel, FaPlus, FaSave, FaTrash } from 'react-icons/fa'
import TransaksiService from '../../../../services/transaksi/TransaksiService'
import { formatDateStringLocalDateINA } from '../../../../utilities/Utils'
import { Link } from 'react-router-dom'
import ModalViewMutuProduksi from './modal/ModalViewMutuProduksi'
import SweetAlert from 'react-bootstrap-sweetalert'
import ModalUploadProduksi from './modal/ModalUploadProduksi'

const ViewMutuProduksi = ({ dataMutuProd, saveMutuProd, cancelMutuProd }) => {
    let transaksiService = useMemo(() => new TransaksiService(), [])

    const [loading, setLoading] = useState()
    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const urlTemplateProduksi = "https://api-siapmutu.kkp.go.id/api/file/view/templates/Template-Data-Mutu-Produksi.xlsx"

    useEffect(() => {
        if (!dataMutuProd) return
        setLoading(true)
        setListData(dataMutuProd.data)
        setTotalData(dataMutuProd.totalData)
        setLoading(false)
    }, [dataMutuProd])

    const handleChangePage = async (page) => {
        const _res = await transaksiService.listPpmMutuProd(localStorage.getItem('nomorAjuStorage'), page - 1, size)
        setListData(_res.data.data)
        setSize(size)
    }

    const handlePerRowsChange = async (size, page) => {
        const _res = await transaksiService.listPpmMutuProd(localStorage.getItem('nomorAjuStorage'), page - 1, size)
        setListData(_res.data.data)
        setSize(size)
    }

    const columns = [
        {
            name: 'Seri',
            cell: row => row['trPpkMutuProdPK'].mutuProdSeri,
            grow: 0
        },
        {
            name: 'Kode Produksi',
            cell: row => row['mutuProdNo'],
        },
        {
            name: 'Tanggal Produksi',
            cell: row => row['mutuProdTgl'] ? formatDateStringLocalDateINA(row['mutuProdTgl']) : ''
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-12 mb-1'>
                            {localStorage.getItem('isEditStorage') === '1' ?
                                <>
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Ubah</Tooltip>}>
                                        <Button size='sm' variant='warning' onClick={() => handleClickEditMutuProd(row, true)}>
                                            <FaEdit />
                                        </Button>
                                    </OverlayTrigger>{' '}
                                    <OverlayTrigger placement="bottom" overlay={
                                        <Tooltip >Hapus</Tooltip>}>
                                        <Button size='sm' variant='danger' onClick={() => handleClickHapusMutuProd(row)}>
                                            <FaTrash />
                                        </Button>
                                    </OverlayTrigger>{' '}
                                </> : ''
                            }
                        </div>
                    </div>
                </>
            ),
            grow: 0.5
        }
    ]

    const [showUploadProduksi, setShowUploadProduksi] = useState(false)
    const handleCloseUploadProduksi = () => setShowUploadProduksi(false)

    const handleClickUploadProduksi = () => {
        setShowUploadProduksi(true)
    }

    const [isEdit, setIsEdit] = useState(false)
    const [dataProduksi, setDataProduksi] = useState(null)
    const [nomorAju, setNomorAju] = useState(null)
    const [showMutuProduksi, setShowMutuProduksi] = useState(false)
    const handleCloseMutuProduksi = () => setShowMutuProduksi(false)

    const handleClickAddMutuProd = () => {
        setIsEdit(true)
        setNomorAju(localStorage.getItem('nomorAjuStorage'))
        setShowMutuProduksi(true)
    }
    const handleClickEditMutuProd = (row, isEdit) => {
        setDataProduksi(row)
        setNomorAju(row.trPpkMutuProdPK.nomorAju)
        setIsEdit(isEdit)
        setShowMutuProduksi(true)
    }

    const [showConfirmHapus, setShowConfirmHapus] = useState(false)
    const handleCloseConfirmHapus = () => setShowConfirmHapus(false)
    const [loadingHapus, setLoadingHapus] = useState(false)
    const [showHapusSuccess, setShowHapusSucces] = useState(false)
    const [showHapusFailed, setShowHapusFailed] = useState(false)

    const handleClickHapusMutuProd = (row) => {
        setDataProduksi(row)
        setShowConfirmHapus(true)
    }

    const handleClickHapus = async () => {
        setLoadingHapus(true)
        try {
            let jsonProdPK = {
                nomorAju: dataProduksi.trPpkMutuProdPK.nomorAju,
                mutuProdSeri: dataProduksi.trPpkMutuProdPK.mutuProdSeri
            }
            const response = await transaksiService.deletePpmMutuProdById(jsonProdPK)
            if (response.data.kode === '200') {
                setShowConfirmHapus(false)
                setShowHapusSucces(true)
            } else {
                setShowConfirmHapus(false)
                setShowHapusFailed(true)
            }
        } catch (error) {
            setShowConfirmHapus(false)
            setShowHapusFailed(true)
        }
        setLoadingHapus(false)
    }

    const handleClickHapusSuccess = () => {
        setShowHapusSucces(false)
        handleChangePage(1)
    }

    const handleClickHapusFailed = () => {
        setShowHapusFailed(false)
        handleChangePage(1)
    }

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <h5 className="mb-4">Data Produksi</h5>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditStorage') === '1' ?
                            <div className="col-8">
                                <Button type="button" variant="primary" size="sm" onClick={() => handleClickAddMutuProd()}><FaPlus />Tambah Kode Produksi</Button>{'  '}
                                <Button type="button" variant="info" size="sm" onClick={() => handleClickUploadProduksi()}><FaFileExcel />Upload Excel</Button>{'  '}
                            </div>
                            :
                            ''
                    }
                    <Link to={urlTemplateProduksi} role='button' size="sm"><span className='text-danger'><i className='icon'><FaDownload /> Download Template Excel Produksi</i></span></Link>{'  '}
                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listData}
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalData}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handlePerRowsChange}
                    persistTableHead={true}
                />
            </div>
            {
                localStorage.getItem('isEditStorage') === '1' ? <>
                    <button type="button" name="next" className="btn btn-primary next action-button float-end btn-sm" value="Next" onClick={() => saveMutuProd('mutuarea')} ><FaSave /> Simpan & Lanjutkan</button>
                    <button type="button" name="previous" className="btn btn-dark previous action-button-previous float-end me-1 btn-sm" value="Previous" onClick={() => cancelMutuProd('mutu')} ><FaArrowLeft /> Sebelumnya</button>
                </> : ''
            }
            <ModalUploadProduksi showUploadProduksi={showUploadProduksi} handleCloseUploadProduksi={handleCloseUploadProduksi} reloadList={handleChangePage}/>
            <ModalViewMutuProduksi showMutuProduksi={showMutuProduksi} handleCloseMutuProduksi={handleCloseMutuProduksi} dataProduksi={dataProduksi} nomorAju={nomorAju} reloadList={handleChangePage} isEdit={isEdit} />
            {
                showConfirmHapus &&
                <SweetAlert
                    title="Hapus Data Produksi?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingHapus ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Hapus...
                            </>
                        ) : (
                            "Hapus"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickHapus}
                    onCancel={handleCloseConfirmHapus}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingHapus}
                >
                    {loadingHapus && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Hapus data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showHapusSuccess &&
                <SweetAlert
                    success
                    title="Hapus Data Produksi Berhasil"
                    onConfirm={handleClickHapusSuccess}
                    btnSize="sm"
                />
            }
            {
                showHapusFailed &&
                <SweetAlert
                    danger
                    title="Hapus Data Produksi Gagal"
                    onConfirm={handleClickHapusFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ViewMutuProduksi